// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"AuthWall_loaderWrapper__xP0GL"};